/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VersionResponse
 */
export interface VersionResponse {
    /**
     * 
     * @type {string}
     * @memberof VersionResponse
     */
    version: string | null;
    /**
     * 
     * @type {string}
     * @memberof VersionResponse
     */
    revision: string | null;
    /**
     * 
     * @type {string}
     * @memberof VersionResponse
     */
    environmentName: string | null;
    /**
     * 
     * @type {string}
     * @memberof VersionResponse
     */
    environmentFlavour: string | null;
}

export function VersionResponseFromJSON(json: any): VersionResponse {
    return VersionResponseFromJSONTyped(json, false);
}

export function VersionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': json['version'],
        'revision': json['revision'],
        'environmentName': json['environmentName'],
        'environmentFlavour': json['environmentFlavour'],
    };
}

export function VersionResponseToJSON(value?: VersionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'revision': value.revision,
        'environmentName': value.environmentName,
        'environmentFlavour': value.environmentFlavour,
    };
}

